import { EducationLayout } from '@src/components/sco/Education/Layout/EducationLayout';
import { EducationMainPanel } from '@src/components/sco/Education/Layout/EducationMainPanel';
import React from 'react';
export const EducationPage = (Component: any) => {
  Component.getLayout = (page: React.ReactElement) => {
    return <EducationLayout mainPanel={<EducationMainPanel>{page}</EducationMainPanel>} />;
  };
  return Component;
};